import * as R from 'ramda';

// possible (R.converge bad signature in @types/ramda) at https://github.com/ramda/ramda/issues/3282
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const capitalize = R.converge(R.concat, [R.compose(R.toUpper, R.head), R.tail]);

export const toTitleCase = R.compose(R.join(' '), R.map(capitalize), R.split(/\s+/));
